<template>
    <div class="alert alert-custom alert-white shadow-sm fade show mb-5" role="alert">
        <div class="alert-icon"><i :class="icon"></i></div>
        <div class="alert-text">{{ text }}</div>
    </div>
</template>

<script>
export default {
    name: "InfoBox",
    props: {
        text: String,
        icon: {
            type: String,
            default: "flaticon-questions-circular-button",
        },
    },
};
</script>
